export const signup = {
	title: "Signup",
	label: {
		accountAlreadyExists: "Account already exists",
		invalidEmail: "Invalid Email",
		notAllowed: "You are not allowed to sign up",
		signupFailed: "Signup failed: Check your inputs and try again."
	}
}